import settings from '@/config/settings';

import type {
  IDatasource,
  IDatasourceCreate,
  IDatasourceUpdate,
} from '@/api/types/datasource';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

import type {IQueryObject} from '@/assets/core/assets/helpers/serialize';

const url = new URL(settings.SERVICES.BACKEND.URL + '/datasource');

export const datasourceAPI = useAPIHook<
  IDatasource,
  IDatasource,
  IDatasourceCreate,
  IDatasourceUpdate,
  IQueryObject
>(url);
